<template>
    <div class="shouye">
        <div class="side">
            <img class="logoIng" src="@/assets/logo/logoL.png" alt="">
            <!-- 侧边导航 -->
            <el-menu 
            :default-active="activeIndex" 
            :unique-opened="true" 
            background-color="#F4F6F8"
            text-color="#333"
            active-text-color="#00C37D">
                <div v-for="(item,index) in asideList" :key="index" >
                    <el-menu-item :class="{'asideBj': activeIndex == item.key}" :index="item.key" v-if="!item.children"  @click="handleSelect(item)">
                        <img v-if="activeIndex == item.key" class="logo-img" :src="item.imgA" alt="">
                        <img v-else class="logo-img" :src="item.img" alt="">
                        <span  class="ziti" slot="title">{{item.title}}</span>
                    </el-menu-item>
                    <!-- 一级菜单（有子菜单）-->
                    <el-submenu :index="item.key" v-if="item.children">
                        <template slot="title">
                            <img class="logo-img" :src="item.img" alt="">
                            <span class="ziti">{{item.title}}</span>
                        </template>
                        <!-- 遍历二级菜单 -->
                        <div v-for="(i,idx) in item.children" :key="idx">
                            <!-- 二级菜单（没有三级菜单）-->
                            <el-menu-item :class="{'asideBj': activeIndex == i.key}" :index="i.key" v-if="!i.children"  @click="handleSelect(i)">
                                {{i.title}}
                            </el-menu-item>
                        </div> 
                    </el-submenu>
                </div>
            </el-menu>
        </div>
        <div class="contenxt">
            <!-- 顶部导航栏 -->
            <TopNavigation class="topnav" />
            <!-- 显示内容 -->
            <div class="infinite-list-wrapper xianshi">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
    
<script>
import TopNavigation from "@/components/TopNavigation.vue";

import { 
    
} from "@/api/api";

export default {
    components:{
        TopNavigation,
        
    },
    data(){
        return{
            activeIndex:sessionStorage.getItem('menu') || '3',
            asideList:[
                // {
                //     key:'1',
                //     title:'首页',
                //     path:'/index',
                //     img:require('@/assets/nav/home.png'),
                //     imgA:require('@/assets/nav/homeL.png'),
                // },
                // {
                //     key:'2',
                //     title:'信息大厅',
                //     path:'/information',
                //     img:require('@/assets/nav/xxdt.png'),
                //     imgA:require('@/assets/nav/xxdtL.png'),
                // },
                {
                    key:'3',
                    title:'接单大厅',
                    path:'/order',
                    img:require('@/assets/nav/jddt.png'),
                    imgA:require('@/assets/nav/jddtL.png'),
                },
                // {
                //     key:'4',
                //     title:'在线发货',
                //     path:'/delivery',
                //     img:require('@/assets/nav/zxfh.png'),
                //     imgA:require('@/assets/nav/zxfhL.png'),
                // },
                {
                    key:'5',
                    title:'订单管理',
                    path:'',
                    img:require('@/assets/nav/ddgl.png'),
                    imgA:require('@/assets/nav/ddgl.png'),
                    children: [
                        {
                            key:'5-1',
                            path: '/carrier_order',
                            title: '承运订单',
                        },
                        // {
                        //     key:'5-2',
                        //     path: '/shipping_order',
                        //     title: '发货订单',
                        // },
                    ]
                },{
                    key:'6',
                    title:'人员管理',
                    path:'/',
                    img:require('@/assets/nav/rygl.png'),
                    imgA:require('@/assets/nav/rygl.png'),
                    children: [
                        {
                            key:'6-1',
                            path: '/driverManagement',
                            title: '司机管理',
                        },{
                            key:'6-2',
                            path: '/dispatcherManagement',
                            title: '调度员管理',
                        },
                    ]
                },
                // {
                //     key:'7',
                //     title:'会员中心',
                //     path:'/memberCenter',
                //     img:require('@/assets/nav/hyzx.png'),
                //     imgA:require('@/assets/nav/hyzxL.png'),
                // },
                {
                    key:'8',
                    title:'车队钱包',
                    path:'/wallet',
                    img:require('@/assets/nav/cdqb.png'),
                    imgA:require('@/assets/nav/cdqbL.png'),
                },{
                    key:'10',
                    title:'消息通知',
                    path:'/message',
                    img:require('@/assets/nav/xxtz.png'),
                    imgA:require('@/assets/nav/xxtzL.png'),
                    children: [
                        {
                            key:'10-1',
                            path: '/systemNotification',
                            title: '系统通知',
                        },{
                            key:'10-2',
                            path: '/orderNotification',
                            title: '订单通知',
                        },{
                            key:'10-3',
                            path: '/messageNotification',
                            title: '留言通知',
                        }
                    ]
                },
                // {
                //     key:'9',
                //     title:'其他信息',
                //     path:'/index',
                //     img:require('@/assets/nav/qtxx.png'),
                //     imgA:require('@/assets/nav/qtxx.png'),
                //     children: [
                //         {
                //             key:'9-1',
                //             path: '/addressBook',
                //             title: '地址薄',
                //         },{
                //             key:'9-2',
                //             path: '/contacts',
                //             title: '通讯录',
                //         },{
                //             key:'9-3',
                //             path: '/commonHeadRaising',
                //             title: '常用抬头',
                //         },{
                //             key:'9-4',
                //             path: '/invoiceRecord',
                //             title: '开票记录',
                //         },
                //     ]
                // }
            ],
        }
    },
    methods:{
        handleSelect(e) {
            console.log(1111,'e',e);
            this.activeIndex = e.key
            if( this.$route.path != e.path && e.path!=''){
                this.$router.push(e.path)
            }
            sessionStorage.setItem('menu',e.key)
        },
        
    },
    mounted(){
        
    }
}
</script>
    
<style style lang="scss" scoped>
.shouye{
    display: flex;
    width: 100%;
    height: 100vh;
}
.side{
    width: 240px;
    height: 100%;
    // background: pink;
    padding-left: 20px;
    box-sizing: border-box;
}

.logoIng{
    width: 118px;
    height: 40px;
    margin-bottom: 40px;
    margin-top: 20px;
    margin-left: 20px;
}

.topnav{
    margin-bottom: 20px;
}

.el-menu{
    border: none;
    width: 200px;
}

.asideBj{
    background: #fff !important;
    border-radius: 10px;
}

.logo-img{
    width: 20px;
    height: 20px;
    margin-right: 16px;
}

.ziti{
    font-size: 16px;
}

.contenxt{
    flex: 1 1 0%;
    // padding: 20px 20px 20px 0px;
    padding: 20px  0px 20px ;

    display: flex;
    flex-direction: column;
}

.xianshi{
    flex: 1 1 0%;
    overflow: auto;
    padding-right: 12px;
}

.txhz{
    display: flex;
    align-items: center;
}
</style>